import styled from "styled-components";
import { useState } from "react";
 
const Button = styled.p`
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    cursor: pointer;
    font-size: 30px;
    color: white;
    text-decoration: none;
    width: auto;
    display: inline-block;

    @media(hover: hover) and (pointer: fine){
        &:hover {
            animation: flash 0.8s infinite;
            text-decoration: underline;
        }
    }

    @media(hover: none) or (pointer: coarse){
        &:hover {
            animation: flash-once 0.8s;
        }
    }

    @keyframes flash {
        0% {
            color: rgb(95, 99, 214);
        }
        49% {
            color: rgb(95, 99, 214);
        }
        50% {
            color: white;
        }
        100% {
            color: white;
        }
    }

    @keyframes flash-once {
        0% {
            color: white;
        }
        25% {
            color: rgb(95, 99, 214);
        }
        49% {
            color: rgb(95, 99, 214);
        }
        50% {
            color: white;
        }
        100% {
            color: white;
        }
    }
`

const NavButton = ({text, setActivePage, setMenuOpen}) => {
    const [animationKey, setAnimationKey] = useState(0);
    
    const handleTouchStart = () => {
        setAnimationKey((prev) => prev + 1);
    };

    const handleClick = () => {
        setActivePage(text);
        setMenuOpen?.(false);
    };

    return(
        <Button
            key={animationKey}
            draggable={false}
            onClick={handleClick}
            onTouchStart={handleTouchStart}
            viewTransition
        >
            {text}
        </Button>
    )
}

export default NavButton;